export const formatPlayerCount = (count?: number | null): string => {
    if (!Number.isFinite(count) || !count || count < 1) {
        return '0';
    }
    if (count < 1000) {
        return String(count);
    }

    const rounded = Math.floor(count / 100) / 10; // Round down to one decimal place
    return Number.isInteger(count / 1000) ? `${count / 1000}k` : `${rounded}k`;
};
